const insertBreak = (str, char) => {
  if (str === null || typeof str === 'undefined') return ''
  return str.replace(new RegExp(` ${char} `, 'g'), "<br />& ")
}

export default insertBreak



// WEBPACK FOOTER //
// ./src/lib/insertBreak.js